import { render } from "./LocaleSelect.vue?vue&type=template&id=626a99b2"
const script = {}

import exportComponent from "L:\\Web\\htdocs\\Testroom\\gruene-mitte\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__